var app = angular.module('leonardo');

var TemplateTriggerAddDialog = function (
  $scope,
  $rootScope,
  $filter,
  ngDialog,
  TemplateTriggerService,
  TemplateService,
  AccountUserService,
  AttachmentService,
  FormErrorsService,
  AuthDataService,
  PermissionService,
  $window, 
  UserService,
) {
  $scope.template = $scope.ngDialogData.template;
  $scope.action = $scope.ngDialogData.action;
  $scope.account = $scope.ngDialogData.account;
  $scope.follow_on = $scope.ngDialogData.follow_on;
  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.tabsCollapsed = [];
  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.templateService = TemplateService;
  $scope.authDataService = AuthDataService;
  $scope.userService = UserService

  $scope.lagTypes = TemplateService.LAG_TYPES;

  $scope.showLagTimeOptions = true;

  $scope.options = [
    { id: 'days', name: 'Days' },
    { id: 'weeks', name: 'Weeks' },
    { id: 'months', name: 'Months' }
  ];

  $scope.isNull = isNull;

  $scope.updateLagTime = function () {
    switch ($scope.data.lag_time_type) {
      case 'days':
        $scope.data.lag_months = null;
        $scope.data.lag_weeks = null;
        break;
      case 'weeks':
        $scope.data.lag_months = null;
        $scope.data.lag_days = null;
        break;
      case 'months':
        $scope.data.lag_weeks = null;
        $scope.data.lag_days = null;
        break;
    }
  };

  $scope.initUsers = function (users) {
    var userIds = [];
    angular.forEach(users, function (user) {
      if (user.id) userIds.push(user.id);
      else userIds.push(user);
    });
    return userIds;
  };

  if ($scope.template) {
    $scope.data = angular.copy($scope.template);
    if ($scope.data.lag_days) {
      $scope.data.lag_time_type = 'days';
    }
    if ($scope.data.lag_weeks) {
      $scope.data.lag_time_type = 'weeks';
    }
    if ($scope.data.lag_months) {
      $scope.data.lag_time_type = 'months';
    }
    $scope.data.creator = $scope.data.creator ? $scope.data.creator.id : null;
    $scope.data.budget = parseFloat($scope.data.budget);
    $scope.data.account_users_assigned = $scope.initUsers($scope.data.account_users_assigned);
    $scope.data.attachments = [];

    if ($scope.data.managed_by) {
      $scope.data.managed_by = $scope.data.managed_by.id ? $scope.data.managed_by.id : $scope.data.managed_by;
    }
    $scope.data.role_based = {
      roles: !isNull($scope.template.roles)
        ? $scope.template.roles.map(function (obj) {
            return obj.id;
          })
        : [],
      role_based_only: !isNull($scope.template.role_based_only) ? $scope.template.role_based_only : false
    };
    if ($scope.template.attachments && $scope.template.attachments.length > 0) {
      var filters = {
        disable_pagination: true,
        id: $scope.template.attachments.join(',')
      };
      $scope.data.attachments = AttachmentService.getlist(filters).$object;
    }
    $scope.data.approval_steps = $filter('orderBy')($scope.data.approval_steps, 'index');
    $scope.data.account_users_assigned = $scope.initUsers($scope.data.account_users_assigned);
    $scope.data.notify_at_approval_complete_users = $scope.initUsers($scope.data.notify_at_approval_complete_users);
    $scope.data.notify_at_approval_terminated_users = $scope.initUsers($scope.data.notify_at_approval_terminated_users);
  }
  else {
    $scope.data = {
      client_instance: AuthDataService.getClientInstance(),
      //white_label: AuthDataService.getWhiteLabel(),
      type: TemplateService.TYPE_TRIGGER,
      fields: {},
      enabled: TemplateService.STATUS_PUBLISHED,
      notify_to: [],
      contact_types: [],
      role_based: {
        roles: [],
        role_based_only: false
      }
    };
  }

  if (AuthDataService.isNotStaff()) {
    $scope.data.account = $scope.account ? $scope.account : AccountUserService.currentAccountUser.account;
    $scope.filtersAccountUsers = { disable_pagination: true, active: true, essential: true, user_is_active: true };
    AccountUserService.getAvailableToAssign($scope.filtersAccountUsers).then(function (data) {
      $scope.usersAccount = data.results;
    });
  }

  $scope.accountUser = AccountUserService.getAccountUser($scope.data.account);

  if ($scope.follow_on) {
    $scope.data.follow_on = $scope.follow_on;
  }

  if ($scope.data.follow_on && $scope.data.lag_type === undefined) {
    $scope.data.lag_type = TemplateService.TYPE_LAG_FS;
  }

  $scope.initUsersRole = function (users) {
    var userIds = [];
    if (!isEmpty(users)) {
      angular.forEach(users, function (user) {
        if ($scope.usersAccount) {
          if ($scope.usersAccount.find((item) => item.id == user)) {
            userIds.push($scope.usersAccount.find((item) => item.id == user));
          }
        } else {
          userIds.push(user);
        }
      });
    }
    return userIds;
  };

  $scope.validationRole = function () {
    var valid = true;
    var account_users_assigned = angular.copy($scope.data.account_users_assigned);
    if (angular.isString(account_users_assigned)) {
      account_users_assigned = account_users_assigned.split(',');
    }
    var users_assigned = $scope.initUsersRole(account_users_assigned);
    if (!isEmpty(users_assigned) && !isEmpty($scope.data.role_based) && !isEmpty($scope.data.role_based.roles)) {
      angular.forEach(users_assigned, function (user) {
        if (!$scope.data.role_based.roles.find((item) => item === user.role)) {
          valid = false;
        }
      });
    }
    return valid;
  }

  $scope.roleValidation = {
    error: 'userRole',
    message: $filter('translate')('The user role of the individual(s) selected to automatically assign to the task should match at least one role selected in Role-based section'),
    validation: $scope.validationRole,
    eventWatch: 'users_roles:updated'
  }

  $scope.getNumber = function (num) {
    return new Array(num);
  };

  $scope.toggleTab = function (tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    } else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function (tab) {
    return _.contains($scope.tabsCollapsed, tab);
  };

  $scope.groupVisible = function (group) {
    var anyVisible = false;

    angular.forEach(group.subgroups, function (subgroup) {
      if (subgroup.data['template_widget'] !== 'hidden') anyVisible = true;
    });
    return anyVisible;
  };

  $scope.getLagType = function () {
    if ($scope.data && $scope.data.lag_type !== null && $scope.data.lag_type !== undefined && $scope.data.lag_type !== '') {
      if ($scope.data.lag_type == TemplateService.TYPE_LAG_FS) {
        $scope.data.start_when_finish = true;
      }
    }
  };

  $scope.getNameAccount = function (account) {
    var array_account = [];
    if (account) {
      array_account = angular.isArray(account) ? account : account.split(',');
    }
    var labels = [];
    angular.forEach(array_account, function (account_id) {
      if (AuthDataService.authData.account) {
        angular.forEach(AuthDataService.authData.account.managed_to_me, function (managed) {
          if (managed.id == account_id) {
            labels.push(managed.name);
          }
        });
      }
    });
    return labels.join(',');
  };

  $scope.removeAttachment = function (index) {
    $scope.data.attachments.splice(index, 1);
  };

  $scope.showAttachment = function (index) {
    if ($scope.data.attachments[index].document_file) {
      // Use signed_view_url for secure inline viewing
      $window.open($scope.data.attachments[index].document_file.signed_view_url || $scope.data.attachments[index].document_file.secure_share_url);
    } else if ($scope.data.attachments[index].link) {
      $window.open($scope.data.attachments[index].link);
    } else {
      if (angular.isObject($scope.data.attachments[index].file)) {
        var reader = new FileReader();
        reader.addEventListener(
          'load',
          function () {
            ngDialog.open({
              template: 'views/templates/dialog/show-image.html',
              className: 'ngdialog-theme-default ngdialog-attachments-view',
              data: {
                name: $scope.data.attachments[index].name,
                src: reader.result
              }
            });
          },
          false
        );
        reader.readAsDataURL($scope.data.attachments[index].file);
      } else {
        // Use signed_view_url for secure inline viewing
        $window.open($scope.data.attachments[index].signed_view_url || $scope.data.attachments[index].secure_share_url || $scope.data.attachments[index].file);
      }
    }
  };

  $scope.showAttachDialog = function () {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/attachment/upload.html',
        controller: 'AttachmentUploadDialog',
        data: { task: $scope.data, mode: 'upload', showManagement: true }
      })
      .then(function (attachments) {
        $scope.data.attachments = [];
        angular.forEach(attachments, function (attachment) {
          $scope.data.attachments.push(attachment);
        });
      }, function () {
        return;
      });
  };
  // approval steps implementation
  $scope.sortApprovalsSteps = function () {
    angular.forEach($scope.data.approval_steps, function (step, index) {
      step.index = index + 1;
    });
  };

  $scope.showAddApprovalDialog = function () {
    if (isNull($scope.data.approval_steps)) {
      $scope.data.approval_steps = [];
    }
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: { index: $scope.data.approval_steps.length + 1 },
          action: 'create'
        }
      })
      .then(function (result) {
        if (result.index === $scope.data.approval_steps.length + 1) {
          $scope.data.approval_steps.push(result);
        } else {
          $scope.data.approval_steps.splice(result.index - 1, 0, result);
          $scope.sortApprovalsSteps();
        }
      });
  };

  $scope.showEditApprovalDialog = function (index) {
    const approval = angular.copy($scope.data.approval_steps[index]);
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: approval,
          action: 'edit'
        }
      })
      .then(function (result) {
        if (index === result.index - 1) {
          $scope.data.approval_steps[index] = result;
        } else {
          $scope.data.approval_steps.splice(index, 1);
          $scope.data.approval_steps.splice(result.index - 1, 0, result);
          $scope.sortApprovalsSteps();
        }
      });
  };

  $scope.deleteApproval = function (index) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/delete-approval.html',
        controller: 'DeleteApprovalStepDialog',
        data: {
          object: $scope.data.approval_steps[index]
        }
      })
      .then(function () {
        $scope.data.approval_steps.splice(index, 1);
        angular.forEach($scope.data.approval_steps, function (approval, indexNew) {
          if (indexNew >= index) {
            approval.index--;
          }
        });
      });
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.getLagType();
    var attachments = angular.copy($scope.data.attachments);
    $scope.data.attachments = [];
    angular.forEach(attachments, function (attachment) {
      $scope.data.attachments.push(attachment.id);
    });
    var users = angular.isArray($scope.data.account_users_assigned) ? $scope.data.account_users_assigned : [];
    if (!isNull($scope.data.account_users_assigned) && !angular.isArray($scope.data.account_users_assigned)) {
      angular.forEach($scope.data.account_users_assigned.split(','), function (value) {
        users.push(value);
      });
    }
    $scope.data.account_users_assigned = users;

    var data = angular.copy($scope.data);
    delete data.lag_time_type;

    delete data.role_based;
    if ($scope.data.role_based) {
      data['roles'] = $scope.data.role_based.roles;
      data['role_based_only'] = $scope.data.role_based.role_based_only;
    }

    if ($scope.data.approval_steps) {
      angular.forEach($scope.data.approval_steps, function (approval, index) {
        data['approval_steps'][index]['user_approvers'] = !isEmpty(approval.user_approvers)
          ? approval.user_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['user_role_approvers'] = !isEmpty(approval.user_role_approvers)
          ? approval.user_role_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['secondary_user_approvers'] = !isEmpty(approval.secondary_user_approvers)
          ? approval.secondary_user_approvers.map((item) => parseInt(item.id || item))
          : [];
          data['approval_steps'][index]['secondary_user_role_approvers'] = !isEmpty(approval.secondary_user_role_approvers)
          ? approval.secondary_user_role_approvers.map((item) => parseInt(item.id || item))
          : [];
      });
    }

    if ($scope.action === 'create') {
      TemplateTriggerService.post(data).then(function (result) {
        if ($scope.workflow) {
          var templates = [];
          angular.forEach($scope.workflow.templates, function (template) {
            templates.push(template.id);
          });
          templates.push(result.id);
          $scope.workflow.patch({ templates: templates }).then(function () {
            $scope.confirm(result);
          });
        } else {
          $scope.confirm(result);
        }
      });
    } else {
      $scope.template.patch(data).then(function (result) {
        $scope.confirm(result);
      });
    }
  };

  $scope.getApprovalName = function (user) {
    return $filter('username')(user) + ' - ' + user.email;
  };

  $scope.$watch('data.role_based.roles', function (newValue,oldValue) {
    if (!angular.equals(newValue, oldValue)) {
      $rootScope.$broadcast('users_roles:updated');
    }
  });
};

app.controller('TemplateTriggerAddDialog', [
  '$scope',
  '$rootScope',
  '$filter',
  'ngDialog',
  'TemplateTriggerService',
  'TemplateService',
  'AccountUserService',
  'AttachmentService',
  'FormErrorsService',
  'AuthDataService',
  'PermissionService',
  '$window',
  'UserService',
  TemplateTriggerAddDialog
]);
